export default "__VITE_ASSET__chjQY6D1__"